import React, { useEffect } from 'react';
import Routes from './Routes';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import { SettingsProvider } from './context/SettingsContext';
import NetworkStatusBanner from './components/errors/NetworkStatusBanner';
import AIChatWidget from './components/AIChatWidget';

function App() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (ref && /^[a-z0-9_-]{1,50}$/i.test(ref)) {
      localStorage.setItem('sdt_ref', ref);
      // Log the click via the backend (fire-and-forget; redirect response is expected)
      fetch(`/api/affiliates/track?ref=${encodeURIComponent(ref)}&to=${encodeURIComponent(window.location.pathname)}`, {
        method: 'GET', credentials: 'include', redirect: 'manual',
      }).catch(() => {});
    }
  }, []);

  return (
    <ToastProvider>
      <AuthProvider>
        <SettingsProvider>
          <NetworkStatusBanner />
          <Routes />
          <AIChatWidget />
        </SettingsProvider>
      </AuthProvider>
    </ToastProvider>
  );
}

export default App;
